<template>
  <div>
    <purchases :id="order.id" :order="order" />
    <promotions :order="order"  :partner="partner" />

    <h4>
      {{ "limit_buyer" | setText("Лимит пользователя") }}:
      {{ (buyer / 100) | spaceBetweenNumber }} UZS
    </h4>

    <h5 v-for="(cond, index) in partner.conditionals" :key="index">
      {{
        (order.price_total + (order.price_total * cond.coefficient) / 100)
          | spaceBetweenNumber
      }}
      UZS - <span class="">{{ cond.month }} {{ "mo" | setText("мес.") }}</span>
    </h5>

    <label>{{
      "select_period_credit" | setText("Выберите период рассрочки")
    }}</label>
    <select class="form-control" v-model="limit">
      <option
        v-for="(cond, index) in partner.conditionals"
        :key="index"
        :value="cond.month"
      >
        {{ cond.month }} {{ "mo" | setText("мес.") }}
      </option>
    </select>

    <div v-if="validate === true">
      <div class="install-control">
        <button @click="next" class="btn btn-success">
          {{ "next_step" | setText("Далее") }}
        </button>
      </div>
    </div>
    <div v-else>
      <h3 class="text-danger">
        {{ "order_error" | setText("Заказ не проходит условию") }}
      </h3>
      <h5>
        {{ "min_price_partner" | setText(" Минимальная цена заказа") }}:
        {{ partner.min_price | spaceBetweenNumber }} UZS
      </h5>
      <h5>
        {{ "max_price_partner" | setText(" Максимальная цена заказа") }}:
        {{ partner.max_price | spaceBetweenNumber }} UZS
      </h5>
      <h5>
        {{ "min_qty_partner" | setText("Минимальное количество товаров") }}:
        {{ partner.min_amount_product | spaceBetweenNumber }} шт.
      </h5>
      <h5>
        {{ "max_qty_partner" | setText("Максимальное кличество товаров") }}:
        {{ partner.max_amount_product | spaceBetweenNumber }} шт.
      </h5>
    </div>
  </div>
</template>
<script>
import Purchases from "@/components/Item/Order/Purchases";
import Promotions from "@/components/Item/Order/Promotions";
import { logger } from "../../../plugins/functions";
export default {
  components: {
    Purchases,
    Promotions,
  },
  props: {
    partner: {
      default: function () {
        return {};
      },
    },
    createTransaction: {
      default: function () {},
    },
    order: {
      default: function () {
        return {};
      },
    },
    hash: {
      default: null,
    },
    buyer: {
      default: 0,
    },
    index: {
      default: 0,
    },
  },
  name: "filter",
  async created() {},
  computed: {
    validate() {
      if (this.partner.min_amount_product > this.order.quantity_total) {
        return false;
      }

      if (this.partner.max_amount_product < this.order.quantity_total) {
        return false;
      }

      if (this.partner.max_price < this.order.price_total) {
        return false;
      }

      if (this.partner.min_price > this.order.price_total) {
        return false;
      }

      return true;
    },
    products: {
      get() {
        let products = [];
        if (this.order && this.order.purchases) {
          for (let i = 0; i < this.order.purchases.length; i++) {
            products.push({
              id: this.order.purchases[i]["barcode"],
              sku: this.order.purchases[i]["barcode"],
              price: this.order.purchases[i]["price"] * 100,
              quantity: this.order.purchases[i]["quantity"],
              name: this.order.purchases[i]["name"],
              weight: "1000",
              url: "",
            });
          }
        }

        return products;
      },
    },
  },
  methods: {
    next() {
      this.save();
    },
    save() {
      this.$loading(true);

      try {
        if (!this.products.length) {
          alert(
            "Товары не применились или в заказе нет товаров. Попробуйте снова"
          );
          this.$store.dispatch("setLastUpdate", new Date());
          return false;
        }
      } catch (error) {}

      logger(this.$http, {
        name: "Создание заказа в #INTEND",
        description: "Начало запроса",
        model_type: "order",
        model_id: this.order.id,
      });

      setTimeout(() => {
        this.$http({
          url: `${this.partner["endpoint_url"]}order/create`,
          method: "POST",
          data: {
            order_id: this.order["id"],
            duration: this.limit,
            redirect_url: "",
            products: this.products,
          },
          headers: {
            "api-key": `${this.partner["api_public_key"]}`,
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${this.hash}`,
          },
        })
          .then((response) => {
            if (response.data && response.data.success && response.data.data) {
              this.message = "Создан успешно заказ";
              this.createTransaction({
                month: this.limit,
                status: response.data.data.status,
                exchange_id: response.data.data.ref_id,
                api_result: JSON.stringify(response.data),
              });
              this.$emit("getContract", response.data.data.ref_id);
              this.$emit("next", 5);
            } else if (response.data.error) {
              this.message = response.data.error["message"];
            } else {
              this.message = "Ошибка сервера - заказ не создан";
            }

            if (this.message) {
              this.$notify({
                title: this.partner.name,
                message: this.message,
                icon: "ti-save",
                horizontalAlign: "right",
                verticalAlign: "top",
              });

              logger(this.$http, {
                name: "Создание заказа в #INTEND",
                description: this.message,
                model_type: "order",
                model_id: this.order.id,
              });
            }
          })
          .catch((error) => {
            logger(this.$http, {
              name: "Создание заказа в #INTEND",
              description: "Системная ошибка #INTEND",
              model_type: "order",
              model_id: this.order.id,
            });

            alert("Ошибка партнера");
          })
          .finally(() => {
            this.$loading(false);
          });
      }, 100);
    },
  },
  data() {
    return {
      message: "",
      limit: 12,
    };
  },
};
</script>
<style lang="scss">
</style>
